import React               from 'react';
import styled              from 'styled-components';
import { TablePagination } from '@material-ui/core';

interface IStyledProps {
  maxWidth?: string;
}

const StyledTablePagination = styled(TablePagination)<IStyledProps>` && {
  display: block;

  ${({ maxWidth }): false | string => !!maxWidth && `max-width: ${maxWidth}`};
}`;

interface IProps {
  totalItems       : number;
  currentPage      : number;
  rowsPerPage      : number;
  handleChangePage : (page: number) => void;
}

export const SearchPagination: React.FC<IProps & IStyledProps> = ({
  maxWidth,
  totalItems,
  currentPage,
  rowsPerPage,
  handleChangePage,
}) => (
  <StyledTablePagination
    count               = {totalItems}
    page                = {currentPage}
    rowsPerPage         = {rowsPerPage}
    onChangePage        = {(event, page) => handleChangePage(page)}
    maxWidth            = {maxWidth}
    rowsPerPageOptions  = {[]}
    labelRowsPerPage    = ""
    backIconButtonProps = {{
      'aria-label': 'Previous Page',
    }}
    nextIconButtonProps = {{
      'aria-label': 'Next Page',
    }}
  />
);

SearchPagination.defaultProps = {
  maxWidth: '800px',
};
